import * as React from "react";
import { Context } from "./_context";
export const CardRefreshIcon = ({ size = 24, variant = "inherit", ...rest }) => {
  const { variants } = React.useContext(Context);
  const color = variants[variant] || "#F0F";
  const props = { "aria-hidden": true, style: { color }, ...rest };
  const iconset = {};
  iconset[24] = /* @__PURE__ */ React.createElement("svg", { width: "1.5rem", height: "1.5rem", fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React.createElement("path", { d: "m18.62 11.62-1.007 1.005h.887A4.375 4.375 0 1 1 14.125 17h1.75a2.625 2.625 0 1 0 2.625-2.625h-.887l1.006 1.006-1.238 1.238-2.5-2.5a.876.876 0 0 1 0-1.238l2.5-2.5 1.238 1.238ZM19.5 4a3 3 0 0 1 3 3v4h-2V7a1 1 0 0 0-1-1h-15a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1H12v2H4.5a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3h15Z", fill: "currentColor" }));
  return iconset[size];
};
CardRefreshIcon.iconId = "lGgQPn";
